module.exports = __webpack_public_path__ + "img/link-tab-icon.0fcc40af.svg";